import { TranslationResponse } from './templates-translation-response-dto.interface';

export interface TemplatesTranslationResponse {
    balanceGroups: TranslationResponse[];
    balanceFlis: TranslationResponse[];
    balanceSubtotals: TranslationResponse[];
    balanceSubflis: TranslationResponse[];
    balanceOfThatItems: TranslationResponse[];
    incomeGroups: TranslationResponse[];
    incomeFlis: TranslationResponse[];
    incomeSubtotals: TranslationResponse[];
    incomeSubflis: TranslationResponse[];
    incomeOfThatItems: TranslationResponse[];
}
